<template>
    <div class="text-2xl my-3 text-secondary-text">
        <the-text-view :value="articleItem.news_headline" />
    </div>
</template>

<script>

    import TheTextView from './TheTextView'

    export default {
        name: 'TheHeadline',
        components: {
            TheTextView
        },
        data() {
            return {
            }
        },

        props: {
            articleItem: {
                type: Object,
                default: () => {}
            }
        },
        created: function() {

        }
    }
</script>